import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/small-down.svg")